import { mapGetters } from 'vuex';
import { Loading } from 'element-ui';
import mixins from '@/mixins';
import { queryRechargePackage, createStripeOrder } from '@/api/shop';
import { report } from '@/api/report';
import Tab from '@/components/Tab/Tab.vue';
import AreaLoading from '@/components/AreaLoading/AreaLoading.vue';
import Dialog from '@/components/Dialog/Dialog.vue';

// 4242 4242 4242 4242
export default {
  name: 'Home',

  mixins: [mixins],

  data() {
    return {
      currentYear: new Date().getFullYear(),
      dataList: [],
      pageLoading: false,
      payType: 'stripe',
      tabList: [
        {
         id: 'stripe',
         name: 'Stripe'
        },
      ]
    }
  },

  computed: {
    ...mapGetters(['userToken', 'appid', 'redirectURL', 'userName', 'userId', 'isLogin', 'balance', 'photo']),
  },

  methods: {
    async init() {
      this.renderGoodsList();
    },

    onTabChange(params) {
      this.payType = params.activeId;
      this.renderGoodsList();
    },

    async renderGoodsList() {
      const userToken = this.userToken || '';
      const appid = this.appid || '';
      const payTypeNow = this.payType;
      const requestPayTypes = {
        apple: 0,
        usdt: 1,
        stars: 2,
        paddle: 3,
        stripe: 4
      };

      this.dataList = [];
      this.pageLoading = true;

      try {
        const res = await queryRechargePackage({
          token: userToken,
          appid,
          type: requestPayTypes[payTypeNow] || 0
        });

        if (payTypeNow !== this.payType) {
          return;
        }

        this.dataList = this.makeRenderList(res.data.list);
      }
      catch(err) {}
      this.pageLoading = false;
    },

    async buy(item) {
      if (!this.isLogin) {
        return;
      }

      const userToken = this.userToken || '';

      if (item.type === 'stripe') {
        this.payByStripe(item);
        return;
      }
    },

    async payByStripe(item) {
      const loading = Loading.service({
        fullscreen: true,
        customClass: 'text-loading',
        text: 'Payment connecting...'
      });
      const userToken = this.userToken || '';
      const appid = this.appid || '';

      try {
        const res = await createStripeOrder({
          appid,
          token: userToken,
          package_id: item.id,
          success_url: this.redirectURL,
          cancel_url: window.location.href
        });
        
        window.location.href = res.data.pay_url;
      }
      catch(err) {
        console.log(err);
        loading.close();
        if (err.code) {
          this.$message({
            message: err.message,
            type: 'error',
            showClose: true,
            customClass: 'custom-message',
          });
          return;
        }
        this.$message({
          message: 'Payment fail.',
          type: 'error',
          showClose: true,
          customClass: 'custom-message',
        });
      }
    },

    makeRenderList(srcList) {
      return srcList.map((item) => {
        let price = `$${item.price}`;

        return {
          id: item.package_id,
          diamonds: item.gems,
          price,
          extra: `${item.extra}%`,
          type: this.payType
        }
      });
    }
  },

  mounted() {
    this.init();
    report({
      event_type: 'view',
      event_value: 'shop'
    });
  },

  components: {
    AreaLoading,
    Tab,
    Dialog
  }
}
